import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import ToggleButton from '@mui/lab/ToggleButton';

import { Card, CardContent, Grid } from '@mui/material';

import { withStyles } from '@mui/styles';
import classnames from 'classnames';
import { FormProvider, useForm } from 'react-hook-form';
import { PubSub } from '../../../../utils/eventUtils';
import { InputLabelBase } from '../../../inputs/InputLabelBase';
import CBButton from '../../../Buttons/CbButton';
import { updateSocialEngg } from '../../../../accounts/AccountService';
import { RegisteredToggleButtonGroup } from '../../../Buttons/registered/v7';
import { EditSection } from '../../../../public/quote/confirm/EditSection';
import { Modal } from '../../../modals/v2/helpers/v2.modal.helpers';
import { InvalidateQuotesConfig } from '../../../modals/InvalidateQuotes';
import { FirmoAndSecurityHeader } from '../../../../console/agencies/quotes/PrimeX/AccountDetails/components/SecurityAssessment';
import useNotifications from '../../../../_lib/notifications/useNotifications';
import { useAPIErrorHandler } from '../../../hooks/useAPIErrorHandler';

const buttonStyles = {
  width: '150px',
  margin: `1.66rem 0 1.66rem 0`,
};

const LabelProps = {
  required: true,
  TypographyProps: {
    variant: 'body2',
    gutterBottom: true,
  },
};

const styles = ({ palette, config, spacing }: any) => {
  return {
    heading: {
      fontWeight: config.weights.bold,
      lineHeight: 1.38,
      marginTop: 0,
    },
    cardContainer: {
      padding: '0px 10px 0px 10px',
    },
    radioButtonsContainer: {
      width: '8vw',
      minWidth: 150,
      height: '3.5vh',
      minHeight: 40,
      paddingRight: '1.25rem',
      border: `1px solid ${palette.primary.contrastText}`,
      borderRadius: 5,
      '& .MuiFormControlLabel-root': {
        marginRight: 0,
      },
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: (props: any) => {
          if (props.from === 'tab' && !props.readOnly) {
            return palette.tabs.profile;
          }
        },
      },
      '& .MuiRadio-colorPrimary.Mui-disabled': {
        color: (props: any) => {
          if (props.from === 'tab' && !props.readOnly) {
            return palette.tabs.profile;
          }
        },
      },
    },
    leftBtn: {
      textAlign: 'right',
      paddingRight: 40,
    },
    cardContentContainer: {
      padding: '5px 0px 5px 0px !important',
      borderTop: `1px solid ${config.colors.darkGreySoft}`,
    },
    buttonContainer: {
      borderTop: `1px solid ${config.colors.darkGreySoft}`,
      justifyContent: 'space-evenly',
      '& .MuiGrid-item': {
        padding: '0px 48px 0 0',
      },
    },
    inputFields: {
      width: '95%',
      float: 'left',
      margin: '0 0 2.5rem 0 !important',
      justifyContent: 'space-evenly',
      '& .MuiGrid-item': {
        padding: '2rem 0 0 8rem',
        display: 'flex',
      },
    },
    attestInput: {
      margin: '0 !important',
      overflow: 'auto',
      '& .MuiGrid-item': {
        padding: '.8rem 0 .2rem 0',
        display: 'flex',
      },
    },
    inactiveBackground: {
      overflow: 'hidden auto',
      padding: '2.5rem 0 0 0',
      backgroundColor: palette.background.paper,
      position: 'relative',
    },
    rowContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      '& .MuiButton-fullWidth': {
        background: 'inherit !important',
      },
    },
    radioButtonsLabel: {
      marginLeft: (props: any) => {
        if (props.from === 'orgProfile') {
          return '8rem';
        }
        return 0;
      },
      marginRight: '3.33rem',
      padding: 0,
      width: '43vw',
      fontFamily: config.fonts.stackSans,
      fontWeight: 300,
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      color: palette.text.text8,
      fontSize: (props: any) => {
        if (props.from === 'orgProfile') {
          return config.textSizes.tertia;
        }
        return config.textSizes.normal;
      },
    },
    divider: {
      borderBottom: `1px solid ${palette.primary.border}`,
    },
    editSection: {
      display: 'flex',

      '& > *': {
        marginLeft: spacing(1),
      },
    },
    toggleButton: {
      padding: '0.5rem 4rem',
    },
    toggleButtonDisabled: {
      color: `${palette.primary.contrastText} !important`,
    },
    parentBox: {
      border: `0.8px solid ${palette.text.secondary}`,
      borderRadius: 5,
      padding: '2rem',
      marginTop: '2rem',
    },
  };
};

const SocialEnggPH = ({
  classes,
  accountId,
  orgData,
  from,
  readOnly,
  togglePrompt,
  onSectionSubmit,
}: any) => {
  const notifications = useNotifications();
  const handleAPIError = useAPIErrorHandler();

  const toggleButtonProps = {
    disabled: readOnly,
    className: classes.toggleButton,
    classes: {
      disabled: classes.toggleButtonDisabled,
    },
  };
  const orgProfile = from === 'orgProfile';
  const [editing, setEditing] = useState(!!orgProfile);

  const defaultValues = {
    isAuthenticatingFundTransferRequests: _.get(
      orgData,
      'isAuthenticatingFundTransferRequests',
      null
    ),
    isVerifyingBankAccounts: _.get(orgData, 'isVerifyingBankAccounts', null),
    isPreventingUnauthorizedWireTransfers: _.get(
      orgData,
      'isPreventingUnauthorizedWireTransfers'
    ),
  };

  const { handleSubmit, ...methods } = useForm({
    defaultValues,
  });
  const {
    formState: { isDirty, isSubmitting },
    getValues,
    reset,
  } = methods;

  const values = getValues();

  useEffect(() => {
    const sub = PubSub.subscribe('cancel-detailChanges', (res: any) => {
      if (res) {
        reset(defaultValues);
      }
    });
    return () => {
      sub.remove();
    };
    // eslint-disable-next-line
  }, []);

  const onSubmit = ({
    isAuthenticatingFundTransferRequests,
    isPreventingUnauthorizedWireTransfers,
    isVerifyingBankAccounts,
  }: any) => {
    const payload = {
      accountId,
      isAuthenticatingFundTransferRequests,
      isPreventingUnauthorizedWireTransfers,
      isVerifyingBankAccounts,
    };

    if (from === 'attestation' && isDirty) {
      setEditing(false);
      Modal.show(InvalidateQuotesConfig, {
        data: {
          update: 'social',
          reset,
          ...payload,
        },
        config: {
          title: `Account Changes for ${orgData.name}`,
        },
      });
    } else {
      updateSocialEngg({}, payload)
        .then(() => {
          notifications.success(
            'Social Engineering Assessment Updated Successfully.'
          );
          if (!orgProfile) {
            setEditing(false);
            PubSub.publish('disable-Submit', false);
            PubSub.publish('fetch-details', true);
            PubSub.publish('org:agent-attested', {
              isVerifiedByAgent: false,
            });
          }
          reset(values);

          if (typeof onSectionSubmit === 'function') {
            onSectionSubmit();
          }
        })
        .catch((error: any) => {
          reset(defaultValues);
          handleAPIError('Something went wrong.Please try agin later.')(error);
        });
    }
  };

  const handleCancel = () => {
    reset(defaultValues);
  };

  useEffect(() => {
    if (togglePrompt) {
      togglePrompt('SOCIAL_ENGG_QUESTIONS', isDirty);
    }
    // eslint-disable-next-line
  }, [isDirty]);

  return (
    // @ts-expect-error TS(2741): Property 'handleSubmit' is missing in type '{ chil... Remove this comment to see the full error message
    <FormProvider {...methods}>
      <Card className={orgProfile ? classes.cardContainer : classes.card}>
        <CardContent
          className={classnames({
            [classes.cardContentContainer]: orgProfile,
          })}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            {!orgProfile && (
              <div className="flex--spaced" style={{ paddingBottom: '1rem' }}>
                <FirmoAndSecurityHeader>
                  Social Engineering
                </FirmoAndSecurityHeader>
              </div>
            )}
            <section className={orgProfile && classes.inactiveBackground}>
              <Grid container justifyContent="left">
                <Grid
                  container
                  justifyContent="left"
                  className={
                    orgProfile ? classes.inputFields : classes.attestInput
                  }
                >
                  <Grid item md={12}>
                    <div>
                      <InputLabelBase {...LabelProps} style={{ paddingTop: 0 }}>
                        Do you or your employees verify vendor/supplier bank
                        accounts before adding to your accounts payable systems?
                      </InputLabelBase>
                      <RegisteredToggleButtonGroup
                        name="isVerifyingBankAccounts"
                        exclusive
                      >
                        <ToggleButton value {...toggleButtonProps}>
                          <div>Yes</div>
                        </ToggleButton>
                        <ToggleButton value={false} {...toggleButtonProps}>
                          <div>No</div>
                        </ToggleButton>
                      </RegisteredToggleButtonGroup>
                    </div>
                  </Grid>
                  <Grid item md={12}>
                    <div>
                      <InputLabelBase {...LabelProps}>
                        Do you or your employees authenticate funds transfer
                        requests (e.g. by calling a customer to verify the
                        request at a predetermined phone number)?
                      </InputLabelBase>
                      <RegisteredToggleButtonGroup
                        name="isAuthenticatingFundTransferRequests"
                        exclusive
                      >
                        <ToggleButton value {...toggleButtonProps}>
                          <div>Yes</div>
                        </ToggleButton>
                        <ToggleButton value={false} {...toggleButtonProps}>
                          <div>No</div>
                        </ToggleButton>
                      </RegisteredToggleButtonGroup>
                    </div>
                  </Grid>
                  <Grid item md={12}>
                    <div>
                      <InputLabelBase {...LabelProps}>
                        Do you or your employees prevent unauthorized employees
                        from initiating wire transfers?
                      </InputLabelBase>
                      <RegisteredToggleButtonGroup
                        name="isPreventingUnauthorizedWireTransfers"
                        exclusive
                      >
                        <ToggleButton value {...toggleButtonProps}>
                          <div>Yes</div>
                        </ToggleButton>
                        <ToggleButton value={false} {...toggleButtonProps}>
                          <div>No</div>
                        </ToggleButton>
                      </RegisteredToggleButtonGroup>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              {!orgProfile && <EditSection show={!readOnly} />}
              {orgProfile && (
                <Grid
                  container
                  justifyContent="center"
                  className={classes.buttonContainer}
                >
                  <Grid item md={4} className={classes.leftBtn}>
                    <CBButton
                      size="large"
                      styleName="cancel"
                      style={buttonStyles}
                      onClick={handleCancel}
                      disabled={isSubmitting || !isDirty}
                    >
                      Cancel
                    </CBButton>
                  </Grid>
                  <Grid item md={4}>
                    <CBButton
                      type="submit"
                      size="large"
                      styleName="ctaButton"
                      style={buttonStyles}
                      loading={isSubmitting}
                      disabled={isSubmitting || !isDirty}
                    >
                      Save Changes
                    </CBButton>
                  </Grid>
                </Grid>
              )}
              <div />
            </section>
          </form>
        </CardContent>
      </Card>
    </FormProvider>
  );
};

// @ts-expect-error TS(2345): Argument of type '({ palette, config, spacing }: a... Remove this comment to see the full error message
export default withStyles(styles)(SocialEnggPH);
